<template>
  <div>
    <div v-if="isEmulating" class="emulation-warning">Emulating: {{ user.name }}</div>
  </div>
</template>

<script>
const loginURL = `${process.env.VUE_APP_API_URL}/login`;
const logoutURL = `${process.env.VUE_APP_API_URL}/logout`;

export default {
  name: 'TopBar',
  props: {
    user: Object,
    isEmulating: Boolean,
  },
  data() {
    return {
      loginURL,
      logoutURL,
    };
  },
  methods: {
    logout() {
      localStorage.clear();
      // eslint-disable-next-line no-restricted-globals
      location.href = this.logoutURL;
    },
  },
};
</script>

<style scoped lang="scss">
  .emulation-warning {
    background: maroon;
    width: 100vw;
    padding: 8px 21%;
    color: white;
  }
  nav {
    border-bottom: 1px solid #dee2e6;
    .navbar-brand img {
      width: 200px;
    }
  }
</style>
